import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useUser } from '../context/UserContext'
import {
  captureDeepLinkFromLocation,
  consumePendingDeepLink,
  peekPendingDeepLink,
} from '../utils/deepLink'

/**
 * Deep links desde correo llegan como:
 *   /?abrir=/solicitudes-excepcion-mora&codigo=EXC-...
 * (la raíz sí existe en S3; /solicitudes-excepcion-mora no).
 * Si hay sesión → navega; si no → guarda y deja que ProtectedRoute/login continúe.
 */
const DeepLinkHandler = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { user } = useUser()

  useEffect(() => {
    const fromUrl = captureDeepLinkFromLocation(location.search)
    if (fromUrl && user) {
      navigate(consumePendingDeepLink() || fromUrl, { replace: true })
      return
    }

    if (user && peekPendingDeepLink()) {
      const pending = consumePendingDeepLink()
      if (pending) navigate(pending, { replace: true })
    }
  }, [location.search, user, navigate])

  return null
}

export default DeepLinkHandler
